import { ReactNode, lazy } from 'react'

const ContentCompletePage = lazy(
  () => import('@/presentation/pages/content/content-complete/content-complete-page')
)

export const makeContentCompletePage = (): ReactNode => {
  return <ContentCompletePage />
}
